import { render, staticRenderFns } from "./ImageFileInput.vue?vue&type=template&id=0c2ea1c1&scoped=true&"
import script from "./ImageFileInput.vue?vue&type=script&lang=ts&"
export * from "./ImageFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./ImageFileInput.vue?vue&type=style&index=0&id=0c2ea1c1&lang=scss&scoped=true&"
import style1 from "./ImageFileInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ea1c1",
  null
  
)

export default component.exports